<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To my darling wife, without whose nagging, (sorry, encouragement,) this book would never have been completed.</p><br/>
<p style="text-align: center;">To my beloved children, Jonathan, Katy, and Beau; and grandchildren, Jay, Ben, Madison, and Georgey Boy. You will no longer need to ask, “What was it like in the olden days, Grandpa?”</p><br/>
<p style="text-align: center;">To my parents, Norman and Joan, whose love of life, numerous adventures, and friendships across the social spectrum inspired me to write this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6e7cef0b